export default {
    login: 'دخول',
    signup: 'تسجيل',
    menu: 'الرئيسية',
    email: 'البريد',
    usernameOrEmail: 'اسم المستخدم او البريد ',
    name: 'الاسم',
    password: 'كلمة المرور',
    forgotPasswordTitle: 'سجل اسم المستخدم او البريد المسجل في الموقع حتى تصلك كلمة المرور الى بريدك الالكتروني',
    forgotPassword: 'نسيت كلمة  المرور؟',
    acceptAgreement: 'بالتسجيل فإنك توافق على الشروط',
    resetPasswordTitle: 'ادخل كلمةالمرور الجديدة',
    resetPassword: 'إرسال كلمة المرور',
    resetPasswordLinkSent: 'تم ارسال كلمة المرور الى بريدك',
    resetPasswordSuccess: 'تم تغيير كلمة المرور بنجاح',
    changePassword: 'تبديل كلمة المرور',
    newPassword: 'كلمة مرور جديدة',
    confirmNewPassword: 'تاكيد كلمة المرور',
    oldPassword: 'كلمة المرور السابقة',
    loginFacebook: 'دخول عبر فايسبوك',
    loginGoogle: 'دخول عبر غوغل',
    register: 'تسجيل',
    logout: 'خروج',
    loggingIn: 'تسجيل دخول',
    next: 'التالي',
    back: 'السابق',
    settings: 'الاعدادات',
    fullList: 'اللائحة الكاملة',
    like: 'اعجاب',
    unlike: 'تجاهل',
    home: 'الرئيسية',
    search: 'البحث',
    chat: 'مراسلة',
    terms: 'شروط الاستخدام',
    support: 'مراسلة ادارة الموقع',
    membershipUpgrade: 'اعلاء العضوية',
    listOfLikes: 'لائحة الاعجاب',
    peopleWhoLikeYou: 'المعجبين بك',
    profileViewers: 'زوار بياناتي',
    noViewers: 'لم يقوم أحد بزيارة بيانك',
    viewersCount: 'عدد الزوار: ',
    profilesViewed: 'بيانات زرتها',
    noViews: 'ليس هناك من زار بيانك',
    viewsCount: 'عدد البيانات التي زرتها: ',
    oppositeLanguage: 'English',
    saveChanges: 'احفظ',
    unblock: 'الغاء تجاهل',
    block: 'تجاهل',
    report: 'أبلغ',
    more: 'المزيد',
    cancel: 'الغاء',
    notifications: 'تنبيهات',
    sharekOmry: 'شريك عمري',
    findMatch: 'ابحث عن شريك',
    unapprovedUser: 'حسابك قيد المراجعة',
    allRightsReserved: `جميع الحقوق محفوظة ${new Date().getFullYear()}`
}
